
<m-expansion-panel [id]="'notaDeCredito'" [title]="'Nota de crédito (Serasa Score)'" [active]="larguraEhSuperiorMin">
  <div *ngIf="!listaServicoFalha.includes('nota-credito')"  id="id-table-notaDeCredito" class="table table-borderless">
    <div>
      <div class="row" *ngIf="notaCredito.score > 0">
        <div class="col-md-12">

          <label class="row etiqueta">Score</label>
          <span class="row" id="id-span-notaDeCredito-score"><strong>{{notaCredito.score | naoinformado}}</strong>  </span>

        </div>
      </div>

      <div class="row" *ngIf="notaCredito.score == 0">

        <div class="col-md-12">
          <span id="id-span-notaDeCredito-score-zero">{{notaCredito.falhaServico.message}} </span>
        </div>

      </div>
    </div>
  </div>
  <div id="id-div-dividasPendentes-dividasParceiros-falha" *ngIf="listaServicoFalha.includes('nota-credito')">
    {{notaCredito.falhaServico.message}}
  </div>
</m-expansion-panel>

